import {Component, ContentChild, EventEmitter, Input, OnChanges, Output, SimpleChange, TemplateRef} from "@angular/core";
import {FUITree} from "./tree/tree.model";

@Component({
    selector: "fui-trees",
    styleUrls: ["./trees.component.scss"],
    templateUrl: "./trees.component.html"
})
export class FUITreesComponent {
    // keep the list of items toggled
    toggled: Map<string, boolean> = new Map();
    @Input() trees: FUITree[];
    @ContentChild("treeheadercontext", {read: TemplateRef}) public treeHeaderContext: TemplateRef<HTMLTemplateElement>;
    @ContentChild("treesheader", {read: TemplateRef}) public treesHeader: TemplateRef<HTMLTemplateElement>;

    /**
     *
     * @param tree
     * @param toggled
     */
    toggleItem(tree: FUITree, toggled: boolean): void {
        this.toggled.set(tree.id, toggled);
        if (tree.parent) {
            let childrenToggled: boolean = false;
            tree.parent.trees.forEach(parentChild => childrenToggled = childrenToggled || this.toggled.get(parentChild.id));
            if (childrenToggled) {
                this.toggleItem(tree.parent, true);
            }
        }
    }

    /**
     *
     * @param index
     * @param item
     */
    trackByFn(index, item) {
        return item.id;
    }
}
